const doc = [({"ko":({"adminConstantHotelDisplayPriceType":({"totalAndPricePerPerson":"총 요금 및 1인당 요금", "totalPriceOnly":"총 요금만"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;